module.exports = __webpack_public_path__ + "static/media/A4.c28b08ec.jpg";